<template>
    <div class="app-router-container" id="app-layout-admin">
      <router-view></router-view>
    </div>
</template>

<script>
export default {
  name: 'WtContainer'
}
</script>

<style scoped>

</style>
